import {
  MEDIA_KEYS,
  MEDIA_TYPES,
} from '@sonifi/wb-media/constants/WbMediaConstants';
import { CONFIRMS_IDS } from '@sonifi/wb-notifier/constants/notifierConstants';

const filterMediaTypes = (mediaTypes, types, match = true) => {
  const typeArray = Array.isArray(types) ? types : [types];
  return mediaTypes.filter(
    (mt) => match ? typeArray.includes(mt.key) : !typeArray.includes(mt.key),
  );
};

const getMediaType = (mediaTypes, typeKey) => (
  mediaTypes.find((mt) => mt.key === typeKey) || mediaTypes[0]
);

export const initialState = {
  folders: {},
  folderNode: {},
  browserTree: [],
  expandedNodes: [],
  isAddingFolder: false,
  confirmScope: CONFIRMS_IDS.wbapp,
  isCurrentlyUploading: false,
  loading: false,
  // Reference count backing `loading`; see setLoadingMedia in mediaSlice.
  pendingFetches: 0,
  mediaPagination: {},
  mediaTypes: MEDIA_TYPES,
  mediaTypeUpload: MEDIA_TYPES[2],
  multiSelect: false,
  noResults: false,
  paneViews: [
    {
      key: 'rows',
      icon: 'list',
      title: 'Browser view',
    },
    {
      key: 'grid',
      icon: 'grid',
      title: 'Thumbnail view',
    },
  ],
  paneViewOption: null,
  plainNodes: {},
  previewMedia: null,
  searchText: '',
  viewMode: null,
};

export const mediaInitialState = {
  layouts: [],
  guestRequestNodeCategory: {
    ...initialState,
    confirmScope: CONFIRMS_IDS.guestRequestNodeCategory,
    mediaType: getMediaType(initialState.mediaTypes, MEDIA_KEYS.TYPE.IMAGES.KEY),
    mediaTypes: filterMediaTypes(initialState.mediaTypes, MEDIA_KEYS.TYPE.IMAGES.KEY),
    viewMode: initialState.paneViews[0],
  },
  happenings: {
    ...initialState,
    mediaTypes: filterMediaTypes(
      initialState.mediaTypes,
      [MEDIA_KEYS.TYPE.SERVICES.KEY, MEDIA_KEYS.TYPE.QRCODES.KEY],
      false,
    ),
    mediaType: getMediaType(initialState.mediaTypes, MEDIA_KEYS.TYPE.MEDIA.KEY),
    viewMode: initialState.paneViews[0],
  },
  happeningSlideEditor: {
    ...initialState,
    mediaTypes: filterMediaTypes(initialState.mediaTypes, MEDIA_KEYS.TYPE.IMAGES.KEY),
    mediaType: getMediaType(initialState.mediaTypes, MEDIA_KEYS.TYPE.IMAGES.KEY),
    viewMode: initialState.paneViews[0],
  },
  irdDefaultImageEditor: {
    ...initialState,
    mediaTypes: filterMediaTypes(initialState.mediaTypes, MEDIA_KEYS.TYPE.IMAGES.KEY),
    mediaType: getMediaType(initialState.mediaTypes, MEDIA_KEYS.TYPE.IMAGES.KEY),
    viewMode: initialState.paneViews[0],
  },
  irdCategoryImageEditor: {
    ...initialState,
    mediaTypes: filterMediaTypes(initialState.mediaTypes, MEDIA_KEYS.TYPE.IMAGES.KEY),
    mediaType: getMediaType(initialState.mediaTypes, MEDIA_KEYS.TYPE.IMAGES.KEY),
    viewMode: initialState.paneViews[0],
  },
  irdNodeItem: {
    ...initialState,
    confirmScope: CONFIRMS_IDS.irdNodeItem,
    mediaTypes: filterMediaTypes(initialState.mediaTypes, MEDIA_KEYS.TYPE.IMAGES.KEY),
    mediaType: getMediaType(initialState.mediaTypes, MEDIA_KEYS.TYPE.IMAGES.KEY),
    viewMode: initialState.paneViews[0],
  },
  sbImageEditor: {
    ...initialState,
    confirmScope: CONFIRMS_IDS.sbImageEditor,
    mediaTypes: filterMediaTypes(initialState.mediaTypes, MEDIA_KEYS.TYPE.IMAGES.KEY),
    mediaType: getMediaType(initialState.mediaTypes, MEDIA_KEYS.TYPE.IMAGES.KEY),
    viewMode: initialState.paneViews[0],
  },
  sbQREditor: {
    ...initialState,
    confirmScope: CONFIRMS_IDS.sbQREditor,
    mediaTypes: filterMediaTypes(initialState.mediaTypes, MEDIA_KEYS.TYPE.QRCODES.KEY),
    mediaType: getMediaType(initialState.mediaTypes, MEDIA_KEYS.TYPE.QRCODES.KEY),
    viewMode: initialState.paneViews[0],
  },
  sbServiceLinkEditor: {
    ...initialState,
    confirmScope: CONFIRMS_IDS.sbServiceLinkEditor,
    mediaTypes: filterMediaTypes(initialState.mediaTypes, MEDIA_KEYS.TYPE.SERVICES.KEY),
    mediaType: getMediaType(initialState.mediaTypes, MEDIA_KEYS.TYPE.SERVICES.KEY),
    viewMode: initialState.paneViews[0],
  },
  sbServiceLinkVideoEditor: {
    ...initialState,
    confirmScope: CONFIRMS_IDS.sbServiceLinkEditor,
    mediaTypes: filterMediaTypes(initialState.mediaTypes, MEDIA_KEYS.TYPE.VIDEOS.KEY),
    mediaType: getMediaType(initialState.mediaTypes, MEDIA_KEYS.TYPE.VIDEOS.KEY),
    viewMode: initialState.paneViews[0],
  },
  sbMenuLinkEditor: {
    ...initialState,
    confirmScope: CONFIRMS_IDS.sbMenuLinkEditor,
    mediaTypes: filterMediaTypes(initialState.mediaTypes, MEDIA_KEYS.TYPE.IMAGES.KEY),
    mediaType: getMediaType(initialState.mediaTypes, MEDIA_KEYS.TYPE.IMAGES.KEY),
    viewMode: initialState.paneViews[0],
  },
};
